import { connect } from "react-redux";

import ChangePassword from "./ChangePassword";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ChangePassword);
